import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { EmailLog, EmailLogParams } from './emailLogs.type';

export const getEmailLogsList = (client: AxiosInstance) => async (params: EmailLogParams) => {
  return (await client.get<PaginatedApiResponse<EmailLog[]>>(API_ROUTES.GET_EMAIL_LOG_LIST, { params })).data;
};

export const emailLogsQueries = {
  all: () => ['email-log'],
  list: (params: EmailLogParams) =>
    queryFactoryOptions<PaginatedApiResponse<EmailLog[]>>({
      queryKey: [...emailLogsQueries.all(), 'list', params],
      queryFn: (client) => () => getEmailLogsList(client)(params),
    }),
};
